import React from 'react';
import { FileSpreadsheetIcon, FileUpIcon, GlobeIcon, HandshakeIcon, InstagramIcon, LayoutTemplateIcon, MegaphoneIcon, Music2Icon, PencilLineIcon, SearchIcon, ShareIcon, SproutIcon, UserPlusIcon, WebhookIcon, YoutubeIcon } from 'lucide-react';
import { LeadSource } from '../../types';
type IconType = React.ComponentType<{
  className?: string;
  style?: React.CSSProperties;
}>;

/** Iconos disponibles al crear o editar una fuente. */
const ICONS: Record<string, IconType> = {
  Instagram: InstagramIcon,
  Facebook: ShareIcon,
  Music2: Music2Icon,
  Youtube: YoutubeIcon,
  Search: SearchIcon,
  Sprout: SproutIcon,
  LayoutTemplate: LayoutTemplateIcon,
  UserPlus: UserPlusIcon,
  Handshake: HandshakeIcon,
  Globe: GlobeIcon,
  PencilLine: PencilLineIcon,
  FileSpreadsheet: FileSpreadsheetIcon,
  FileUp: FileUpIcon,
  Webhook: WebhookIcon,
  Megaphone: MegaphoneIcon
};
export const SOURCE_ICON_OPTIONS = Object.keys(ICONS).map(value => ({
  value,
  label: value
}));
export function sourceIcon(name?: string): IconType {
  return name && ICONS[name] || GlobeIcon;
}

/** Fuentes conocidas cuando la organización todavía no las ha personalizado. */
const FALLBACK: Record<string, {
  label: string;
  icon: string;
  color: string;
}> = {
  instagram: {
    label: 'Instagram',
    icon: 'Instagram',
    color: '#C13584'
  },
  facebook: {
    label: 'Facebook',
    icon: 'Facebook',
    color: '#1877F2'
  },
  tiktok: {
    label: 'TikTok',
    icon: 'Music2',
    color: '#0B0B0F'
  },
  google: {
    label: 'Google',
    icon: 'Search',
    color: '#EA4335'
  },
  linkedin: {
    label: 'LinkedIn',
    icon: 'Facebook',
    color: '#0A66C2'
  },
  organico: {
    label: 'Orgánico',
    icon: 'Sprout',
    color: '#16A34A'
  },
  landing: {
    label: 'Landing',
    icon: 'LayoutTemplate',
    color: '#3D8BFF'
  },
  web: {
    label: 'Web',
    icon: 'Globe',
    color: '#5F6673'
  },
  manual: {
    label: 'Manual',
    icon: 'PencilLine',
    color: '#F59E0B'
  },
  referido: {
    label: 'Referido',
    icon: 'UserPlus',
    color: '#7C5CFF'
  },
  csv: {
    label: 'CSV',
    icon: 'FileSpreadsheet',
    color: '#0EA5E9'
  },
  webhook: {
    label: 'Webhook',
    icon: 'Webhook',
    color: '#DB2777'
  },
  directo: {
    label: 'Directo',
    icon: 'Globe',
    color: '#5F6673'
  }
};
interface SourceBadgeProps {
  source?: string;
  /** Fuentes configuradas por la organización. */
  sources?: LeadSource[];
}

/** Muestra la fuente del lead con el icono y el color configurados. */
export function SourceBadge({
  source,
  sources
}: SourceBadgeProps) {
  const key = (source || 'directo').toLowerCase();
  const custom = sources?.find(s => s.key === key);
  const entry = custom ? {
    label: custom.name,
    icon: custom.icon,
    color: custom.color
  } : FALLBACK[key] ?? {
    label: source || 'Directo',
    icon: 'Globe',
    color: '#5F6673'
  };
  const Icon = sourceIcon(entry.icon);
  return <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full px-2.5 py-1 text-xs font-medium" style={{
    backgroundColor: `${entry.color}14`,
    color: entry.color
  }} data-id="element-195" data-mp="10ije5qbkig5l">
      <Icon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-196" data-mp="2g43s5qmsqv0n" />
      {entry.label}
    </span>;
}